import React from 'react';
import Modal from 'react-modal';

import {IMG_CONFIG} from '../2dReact/2dConfig';
import './Common.css';

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];

//Summary_Sept18_0000_Sept19_0000.csv
function makeFileName(from, to) {
  let start = new Date(from)
  let end = new Date(to)

  let start_hour = start.getHours() < 10 ? "0" + start.getHours() : start.getHours()
  let start_min = start.getMinutes() < 10 ? "0" + start.getMinutes() : start.getMinutes()
  let end_hour = end.getHours() < 10 ? "0" + end.getHours() : end.getHours()
  let end_min = end.getMinutes() < 10 ? "0" +  end.getMinutes() : end.getMinutes()

  let str = monthNames[start.getMonth()] + start.getDate() + "_" + start_hour + start_min + "_" +
            monthNames[end.getMonth()] + end.getDate() + "_" + end_hour + end_min + ".csv";
  return (str)
}

function makeTextFile (text, link) {
   var textFile;
   var data = new Blob([text], {type: 'text/plain'});
   if (link !== null) {
     window.URL.revokeObjectURL(link);
   }

   textFile = window.URL.createObjectURL(data);
   return textFile;
 };

class Download extends React.Component {
  constructor() {
    super();

    this.state = {
      file_name: "",
      message: "",
      file_content: "",
      modalIsOpen: false,
      link: null,
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.updateFileName = this.updateFileName.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
  }

  openModal() {
    this.setState({modalIsOpen: true, file_name: makeFileName(this.props.from, this.props.to), file_content: "", message: "", link: null});
  }

  closeModal() {
    this.setState({modalIsOpen: false, file_name: "", file_content: "", message: "", link: null});
  }

  updateFileName(e) {
    this.setState({file_name: e.target.value});
  }

  downloadFile(e) {
    //error checking
    if (this.state.file_name.trim().length === 0) {
      this.setState({message: "Empty filename"});
      return;
    }

    this.setState({message: "Creating file..."});
    let link = makeTextFile(this.props.file_content, this.state.link);
    this.setState({message: "", link: link});
  }

  render() {
    return (
      <div className="common" style={{display: "inline-block"}}>
        <img className="MapTypeIcon" alt="download" src={IMG_CONFIG['download']['active']['img']} onClick={this.openModal}/>
        <Modal
          ariaHideApp={false}
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          contentLabel="Download"
          className="Upload"
        >
        <img className="xImg" alt="close" src={require("./img/x.png")} onClick={this.closeModal}/>
        <div className="UploadContainer">
          <div>Download Data</div>
          <div className="SelectFileText">Filename</div>
          <input type="text" size="40" placeholder={this.state.file_name} name="Choose File" onChange={this.updateFileName} />
          <div>
            <div className="DownloadButton">
              <div className="UploadText" onClick={this.downloadFile}>CREATE</div>
            </div>
            <div className="LoadingStatus">{this.state.message}</div>
            <div className="LoadingStatus" style={{display: this.state.link ? "inline-block" : "none"}}><a href={this.state.link} download={this.state.file_name}>Download File</a></div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default Download;
